<template>
  <div class="container">
    <div class="s-task-cart">
        <h4 class="s-title_big">
          {{info.name}}
          <p><strong class="brand-name">{{info.brandName}}</strong><span class="time">{{info.updateDate}}</span></p>
        </h4>
    </div>
    <div class="s-task-cart">
        <h4 class="s-title">
          活动描述
        </h4>
        <div class="s-task-content">
         {{info.content}}
        </div>
    </div>
    <div class="s-task-cart">
        <h4 class="s-title">
          报名要求
        </h4>
        <div class="s-required-box">
          <div class="s-required">
            <label>粉丝量:</label> {{numberFormat(info.requiredFansCount)}}~{{numberFormat(info.maxFansCount)}}万人
          </div>
          <div class="s-required">
            <label>单人报价:</label> {{info.price/10000}}~{{info.maxPrice/10000}}万元
          </div>
          <div class="s-required">
            <label>人数:</label> {{info.requiredSubmitCount}}
          </div>
          <div class="s-required">
            <label>截止时间:</label> {{info.submitEndTime}}
          </div>
        </div>
    </div>
    <login-dialog :visible="loginDialogVisible" @success="loginSuccess"></login-dialog>
    <div class="s-fixed-button">
        <div class="s-fixed-button-wrap">
          <button class="s-button s-button-primary s-button-block container" @click="apply">我要报名</button>
        </div>
    </div>
  </div>
</template>

<script>
import config from '@/utils/config'
import auth from '@/utils/auth'
import utils from '@/utils/index'
import LoginDialog from '@/components/login-dialog'

export default {
  name: 'taskDetail',
  data () {
    return {
      numberFormat: utils.numberFormat,
      loginDialogVisible: false,
      info: {}
    }
  },
  methods: {
    getInfo () {
      this.$http.get(`${config.HOST}douyin/v1/task/get?id=${this.$route.params.id}`)
        .then(response => {
          let data = response.body
          if (data.code === 0) {
            this.info = data.data
            this.info.updateDate = this.info.updateTime.substr(0,10)
          } else {

          }
        }, response => {
        // error callback
        })
    },
    apply() {
      let token = auth.getToken();
      if (token) {
        this.$http.post(`${config.HOST}douyin/v1/task/submit`,{
          id:parseInt(this.$route.params.id)
        })
        .then(response => {
          let data = response.body
          if (data.code === 0) {
            this.$toast.show('申请成功');
          } else {
            this.$toast.show(data.errorMessage || '申请失败');
          }
        }, response => {
        // error callback
        })
      } else {
        this.loginDialogVisible = true
      }
    },
    loginSuccess(){
      this.loginDialogVisible = false;
      this.apply()
    }
  },
  mounted () {
    this.getInfo()
  },
  components: {
    'login-dialog': LoginDialog
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../index.less";
  .s-task-cart{
    background: #161823;
    margin-bottom: 15px;
    &>.s-title_big{
      color:#fff;
      font-size:16px;
      padding: 15px;
      overflow: hidden;
      .brand-name{
        color: #FE2B55;
        font-size: 12px;
        margin-right:10px;
        font-weight: 100;
      }
      .time{
        color:#9F9EA0;
        font-size: 12px;
      }
    }
  }
  .s-task-content{
    padding: 15px;
    color: #fff;
  }
  .s-required{
    padding: 0 15px 15px;
    color:#fff;
    &>label{
      color:#9F9EA0;
      margin-right: 15px;
    }
  }
  .s-required-box{
    background: url(../../assets/images/task_bg.png) no-repeat;
    background-size:60px 73px;
    background-position: bottom right;
  }
</style>



// WEBPACK FOOTER //
// src/containers/task/Index.vue